import type { AdminAuditAction } from '../../../../domain/superadmin/types';
import type { AdminOrganizationDetail } from '../../../../domain/superadmin/types';
import { formatDateTime } from '../../../../utils/formatters';
import DashboardCard from '../../../dashboard/components/DashboardCard';
import { SectionEmpty } from './SectionEmpty';

type AuditSectionProps = {
  audit: AdminOrganizationDetail['audit'];
};

const AUDIT_ACTION_LABELS: Record<AdminAuditAction, string> = {
  impersonation_start: 'Entrada em modo suporte',
  impersonation_end: 'Saída do modo suporte',
  org_block: 'Empresa bloqueada',
  org_unblock: 'Empresa desbloqueada',
  org_note_save: 'Nota interna atualizada',
  user_delete: 'Usuário excluído',
};

function auditActionLabel(action: string) {
  const key = action as AdminAuditAction;
  return AUDIT_ACTION_LABELS[key] ?? action.replace(/_/g, ' ');
}

export function AuditSection({ audit }: AuditSectionProps) {
  return (
    <DashboardCard title="Histórico administrativo" className="mb-s5">
      {audit.length === 0 ? (
        <SectionEmpty message="Nenhum evento administrativo registrado." />
      ) : (
        <ol className="relative flex flex-col gap-s4 border-l border-subtle pl-s4">
          {audit.map((event) => (
            <li key={event.id} className="relative">
              <span
                className="absolute -left-[calc(1rem+5px)] top-1.5 size-2.5 rounded-full border-2 border-card bg-primary"
                aria-hidden
              />
              <div className="rounded-lg border border-subtle bg-surface px-s4 py-3">
                <div className="flex flex-wrap items-baseline justify-between gap-s2">
                  <p className="text-[13px] font-medium text-default">
                    {auditActionLabel(event.action)}
                  </p>
                  <time
                    className="font-mono text-[11.5px] tabular-nums text-muted"
                    dateTime={event.createdAt}
                  >
                    {formatDateTime(event.createdAt)}
                  </time>
                </div>
                {event.reason && (
                  <p className="mt-2 text-[12px] leading-relaxed text-secondary">{event.reason}</p>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </DashboardCard>
  );
}
